import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NumberInput from 'screens/components/basic/NumberInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "BudgetPlanner";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-5 col-xl-4">
                <NumberInput
                    name={componentName + "Budget"}
                    fullWidth={true}
                    hintText={"Budget"}
                    label={"Budget"}
                    floatingLabelText={"Budget"}
                />
            </div>
            <div className="col-xs-12 col-sm-7 col-xl-4">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-xl-4">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
